import { create, show, useModal } from "@ebay/nice-modal-react";

import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";

type ProviderVersionDeleteConfirmationProps = {
  onConfirm: () => void;
  isPublished: boolean;
  versionNumber: string;
};

const ProviderVersionDeleteConfirmation = create(function ProviderVersionDeleteConfirmation({
  onConfirm,
  isPublished,
  versionNumber,
}: ProviderVersionDeleteConfirmationProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    onConfirm();
    modal.hide();
  };

  return (
    <DeleteConfirmationModal
      onConfirm={handleOnConfirm}
      confirmationButtonLabel={isPublished ? "Revoke" : "Delete"}
    >
      <ConfirmationModalMessage>
        Are you sure you want to {isPublished ? "revoke" : "delete"} version{" "}
        <strong>{versionNumber}</strong>?
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showProviderVersionDeleteConfirmation = (
  props: ProviderVersionDeleteConfirmationProps
) => show(ProviderVersionDeleteConfirmation, props);
